import { FC, useState, useContext, useEffect, useRef, useMemo } from 'react';
import './floatingHelp.scss';
import { floatingHelpContent } from '@/_data/contentText';
import { FloatingHelpProps, FloatingHelpStates, FloatingHelpContent } from '@/model/floatingHelp/FloatingHelp';
import { AppContext } from '@/context/AppContext';
import { Icon } from '@/comp/icon/icon';

const FloatingHelp: FC<FloatingHelpProps> = () => {
    const context = useContext(AppContext);

    const [state, setState] = useState<FloatingHelpStates>({
        isOpen: false,
        isAnimated: false,
    });

    const firstRenderRef = useRef(true);
    const animatedClass = !firstRenderRef.current && state?.isAnimated ? 'animated' : '';

    const showOnSpot = Boolean(context?.bookingData?.data?.allowedInteractions?.onSpot);
    const content: FloatingHelpContent = useMemo(
        () => ({
            ...floatingHelpContent.OnSpot,
            content: floatingHelpContent.OnSpot.content.filter((item) => item.id !== 'onSpot' || showOnSpot),
        }),
        [showOnSpot]
    );

    useEffect(() => {
        if (firstRenderRef.current) {
            firstRenderRef.current = false;
        }
    }, []);

    const handleClick = () => {
        setState((prev) => ({
            ...prev,
            isOpen: !prev.isOpen,
            isAnimated: true,
        }));
    };

    return (
        <div className={`floating-help ${state?.isOpen ? 'open' : ''} ${animatedClass}`}>
            <div className="floating-help-head" onClick={handleClick}>
                <Icon name="tipLightbulb" size={40} ariaHidden />
                <div className="floating-help-content-text text-bold">{content.headline}</div>
            </div>
            <div className="floating-help-content">
                {content.content.map((item, index) => (
                    <a
                        key={index}
                        href={item.link?.url}
                        target={item.link?.target || '_self'}
                        rel="noopener noreferrer">
                        <span className="text">{item.text}</span>
                        <Icon name="openInNew" size={20} ariaHidden />
                    </a>
                ))}
            </div>
        </div>
    );
};

export default FloatingHelp;
